module.exports = __webpack_public_path__ + "static/media/windowsColoredIcon.5d190a01.svg";